import { render, staticRenderFns } from "./KategoriKerusakan.vue?vue&type=template&id=4187b7bd&"
import script from "./KategoriKerusakan.vue?vue&type=script&lang=js&"
export * from "./KategoriKerusakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports